import shippingMethods from '~/assets/constants/shopify/shipping-methods.json'
import shippingConfig from '~/assets/constants/shopify/shipping-config.json'

export const useShippingData = defineStore('shippingConfig', {
  state: () => ({
    methods: shippingMethods,
    config: shippingConfig,
    destination: useRoute()?.params?.locale?.toString().split('-')[1].toUpperCase() || 'GB',
  }),

  actions: {
    setDestination(country: string) {
      this.destination = country
    }
  },

  getters: {
    currentCountryMethods: (state) => {
      if (!state.methods.length) return false
      return state.methods.filter((method) => method.isoCode === state.destination)
    },
    fastestMethod(): object | undefined {
      if (!this.currentCountryMethods) return
      
      // Return method with lowest minimum transit time (or max transit time if two share)
      return this.currentCountryMethods.reduce(
        (
          fastestMethod: { transitMin: number; transitMax: number },
          method: { transitMin: number; transitMax: number },
        ) => {
          if (!fastestMethod) return method

          if (method.transitMin < fastestMethod.transitMin) {
            return method
          } else if (
            method.transitMin === fastestMethod.transitMin &&
            method.transitMax < fastestMethod.transitMax
          ) {
            return method
          } else {
            return fastestMethod
          }
        },
        undefined,
      )
    },
    saturdayMethod(): object | undefined {
      if (!this.currentCountryMethods) return
      const saturdayMethod = this.currentCountryMethods.find(method => method.type === 'Saturday');
      return saturdayMethod;
    }
  },

  persist: {
    storage: piniaPluginPersistedstate.localStorage(),
    pick: ['destination'],
  },
})
